import PropTypes from 'prop-types';

const SuperBatchResourceType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
});

export default SuperBatchResourceType;
